module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HsWUJ5/images/cover.jpg?1708648506556",
      "alt": "This image is the cover for the book American Spirit"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("American Spirit\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The United States is an exceptional place to call home thanks to the character of the American people. With conviction and urgency, Ed Feulner and Brian Tracy affirm our core tenets?from patriotism and optimism to faith and generosity?and challenge all of us to live out the timeless principles of citizenship.")]), _c('p', [_vm._v("Packed with engaging stories, insightful profiles, and eye-opening statistics, "), _c('i', [_vm._v("The American Spirit")]), _vm._v(" serves as an indispensable primer on the bedrock belief that an indomitable spirit "), _c('i', [_vm._v("does")]), _vm._v(" exist, that it defines us as a people, and that it must be preserved for the nation to flourish.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Edwin J. Feulner, Brian Tracy\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0